export default "__VITE_ASSET__DzIgXNFD__"